import { Scope as e } from "./chunk885.js";
import { getGlobalSingleton as t } from "./chunk850.js";
function r() {
  return t("defaultCurrentScope", () => new e());
}
function u() {
  return t("defaultIsolationScope", () => new e());
}
export {
  r as getDefaultCurrentScope,
  u as getDefaultIsolationScope
};
